// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c7TS","tabsBox":"styles_tabsBox__1x3zP","createButton":"styles_createButton__2DbfA"};